import { jsx as _jsx } from "react/jsx-runtime";
import { Image as HeroImage } from '@heroui/react';
export const Image = (props) => {
    return _jsx(HeroImage, { ...props });
};
export default Image;
//# sourceMappingURL=Image.js.map